//========================================================================================
/*
    practitioner  [obj]
 */
//========================================================================================


import React from 'react';

// Services
import { getTranslateDocSpecialties, getPractitionerName } from 'src/views/practitioner/services/appointments';

// Styles & Images
import s from './PractitionerBlock.style';
import DefaultPractitioner from 'assets/images/default-practitioner.svg';


const PractitionerBlock = (props) => {
  const { practitioner } = props;

  return (practitioner ?
    <s.DoctorBlockWrapper className="doctor-block-container">
      <div className="photo-wrapper">
        <img src={practitioner.photo || DefaultPractitioner} alt="practitioner" />
      </div>
      <div className="practitioner">
        <p className="now-wrap">{getPractitionerName(practitioner)}</p>
        <p className="specialties now-wrap">{getTranslateDocSpecialties(practitioner)}</p>
      </div>
    </s.DoctorBlockWrapper>
    : null
  );
};

export default PractitionerBlock;
